var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.id,
            "hide-footer": "",
            centered: "",
            "header-close-label": _vm.$t("Btn_Close")
          },
          on: {
            shown: function($event) {
              return _vm.focus()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _c(
                    "label",
                    { attrs: { for: _vm.id + "-dialogcheckboxlist" } },
                    [_vm._v(_vm._s(_vm.$t(_vm.title)))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _vm.options.length > 0
            ? _c(
                "div",
                _vm._l(_vm.options, function(option) {
                  return _c(
                    "div",
                    { key: option.id, staticClass: "mt-4 mb-4" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedValues,
                            expression: "selectedValues"
                          }
                        ],
                        ref: "inputToFocus",
                        refInFor: true,
                        attrs: {
                          type: "checkbox",
                          name: _vm.title,
                          id: _vm.getInputId(option),
                          disabled: _vm.isReadOnly,
                          "aria-disabled": _vm.isReadOnly
                        },
                        domProps: {
                          value: option,
                          checked: Array.isArray(_vm.selectedValues)
                            ? _vm._i(_vm.selectedValues, option) > -1
                            : _vm.selectedValues
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.selectedValues,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = option,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.selectedValues = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.selectedValues = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.selectedValues = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "d-inline-block align-top w-85",
                          staticStyle: { "white-space": "pre-wrap" },
                          attrs: { for: _vm.getInputId(option) }
                        },
                        [_vm._v(_vm._s(option.name))]
                      )
                    ]
                  )
                }),
                0
              )
            : _c("div", [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t(_vm.noOptionsString)) + "\n    "
                )
              ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }